import {
  DeleteOutlined,
  EditOutlined,
  FormOutlined,
  TagsOutlined,
  ShopOutlined,
  AppstoreOutlined,
  CloseCircleOutlined
} from "@ant-design/icons";
import { Button, Modal } from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DeleteSvg from "../../Assets/Svg/delete";
import { cancel_table, delete_table } from "../../Controllers/Global";
import toast from "react-hot-toast";
import { get_user_auth } from "../../Controllers/Layouts/Layouts";
import AssignCategoryModal from "../../Pages/Products/Categories/Table/AssignCategoryModal.js";
import AssignBrandModal from "../../Pages/Products/Brands/Table/AssignBrandModal.js";
import AssignUnitModal from "../../Pages/Products/Units/Table/AssignUnitModal.js";
import {
  checkUpdatePermission,
  checkDeletePermission,
} from "../../Main/permissionUtils.js";
import FeatureLockWrapper from "../FeatureLocksWrapper/index.js";
import FeatureUnlockRequestModal from "../FeatureRequestMailForm/index.js";

const ActionButton = (props) => {
  let navigate = useNavigate();

  const edit = props?.edit ? props?.edit : "";
  const id = props?.id ? props?.id : "";
  const cat_Id = props?.cat_Id ? props?.cat_Id : "";
  const brand_Id = props?.brand_Id ? props?.brand_Id : "";
  const unit_Id = props?.brand_Id ? props?.unit_Id : "";
  const api = props?.api ? props?.api : "";
  const actiondata = props?.actiondata;
  const headers = props?.headers;

  const cancelApi = props?.cancelApi || "";

  const [isModalOpens, setIsModalOpens] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const productName = props?.productName || "";
  const productData = props?.productData || {};
  const unitData = props?.unitData || {};
  const type = props?.type || "";
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [isBrandModalOpen, setIsBrandModalOpen] = useState(false);
  const [isUnitModalOpen, setIsUnitModalOpen] = useState(false);

  const [unitUnlocked, setUnitUnlocked] = useState(false);
  const [catUnlocked, setCatUnlocked] = useState(false);
  const [brandUnlocked, setBrandUnlocked] = useState(false);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const fetchFeatureUnlocks = async () => {
      const unit =
        await FeatureLockWrapper.isFeatureUnlocked("unit_assignment");
      const cat = await FeatureLockWrapper.isFeatureUnlocked(
        "category_assignment",
      );
      const brand =
        await FeatureLockWrapper.isFeatureUnlocked("brand_assignment");

      setUnitUnlocked(unit);
      setCatUnlocked(cat);
      setBrandUnlocked(brand);
    };

    fetchFeatureUnlocks();
  }, []);

  const handleModal = (e) => {
    e?.stopPropagation();
    setIsModalOpens(!isModalOpens);
  };

  const handleCategoryModal = (e) => {
    e?.stopPropagation();
    setIsCategoryModalOpen(!isCategoryModalOpen);
  };

  const handleBrandModal = (e) => {
    e?.stopPropagation();
    setIsBrandModalOpen(!isBrandModalOpen);
  };

  const handleUnitModal = (e) => {
    e?.stopPropagation();
    setIsUnitModalOpen(!isUnitModalOpen);
  };

  const handleDelete = async (e) => {
    e?.stopPropagation();

    if (deleting) return; // Prevent multiple clicks
    setDeleting(true);
    const data = {
      api: api,
      id: id,
    };

    const deleteTable = await delete_table(data);
    setDeleting(false); // // always release lock

    if (deleteTable?.status) {
      actiondata(data?.id);
      toast?.success(deleteTable?.message);
      setIsModalOpens(!isModalOpens);
    } else {
      setIsModalOpens(!isModalOpens);
      if (deleteTable?.status_code == 403) {
        window.location.href = "/unauthorized";
      } else {
        toast?.error(deleteTable?.message);
      }
    }
  };

  const fetchUserData = async () => {
    try {
      setLoading(true);
      const layouts = await get_user_auth();
      setUserData(layouts?.data || layouts);
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleAssignmentSuccess = () => {
    if (type === "category") {
      setIsCategoryModalOpen(false);
    } else if (type === "brand") {
      setIsBrandModalOpen(false);
    } else if (type === "unit") {
      setIsUnitModalOpen(false);
    }
    if (actiondata) {
      actiondata();
    }
  };

  const canEdit = !loading && checkUpdatePermission(headers, userData);
  const canDelete = !loading && checkDeletePermission(headers, userData);
  const canCancel = !loading && checkDeletePermission(headers, userData);

  const [selectedFeature, setSelectedFeature] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLockedClick = (e, feature) => {
    e.preventDefault();
    setSelectedFeature(feature);
    setIsModalOpen(true);
  };

  const handleCancelModal = (e) => {
    e?.stopPropagation();
    setIsCancelModalOpen(!isCancelModalOpen);
  };

  const handleCancel = async (e) => {
    e?.stopPropagation();

    console.log("shdasnkdsads", cancelApi);
    const data = {
      cancelApi: cancelApi,
      id: id,
    };

    const cancelTable = await cancel_table(data);
    if (cancelTable?.status) {
      actiondata(data?.id);
      toast?.success(cancelTable?.message);
      setIsCancelModalOpen(!isModalOpen);
    } else {
      setIsCancelModalOpen(!isModalOpen);
      if (cancelTable?.status_code == 403) {
        window.location.href = "/unauthorized";
      } else {
        toast?.error(cancelTable?.message);
      }
    }
  };

  return (
    <div className="text-xl text-gray-600 ">
      <Modal
        open={isModalOpens}
        onCancel={handleModal}
        centered={true}
        footer={[
          <div>
            <div className="">
              <Button
                className="cancel-btn transition duration-700 ease-in-out font-medium mr-2"
                onClick={handleModal}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                className="delete-btn transition duration-700 ease-in-out font-medium text-red-500 border-red-500"
              >
                Delete
              </Button>
            </div>
          </div>,
        ]}
      >
        <div>
          <div className="flex justify-center item-center py-2">
            <DeleteSvg className="text-red-600" width={40} height={40} />
          </div>

          <div className="py-4">
            <div className="text-xl text-medium text-center">
              Your about to delete
            </div>
            <div className="py-4">
              <div className="text-base text-gray-400 text-center">
                Are you sure want to delete ? You
              </div>
              <div className="text-base text-gray-400 text-center">
                will <span className="text-red-500">not be able to revert</span>
                &nbsp;this.
              </div>
            </div>
          </div>
        </div>
      </Modal>

        <Modal
        open={isCancelModalOpen}
        onCancel={handleCancelModal}
        centered={true}
        footer={[
          <div>
            <div className="">
              <Button
                className="cancel-btn transition duration-700 ease-in-out font-medium mr-2"
                onClick={handleCancelModal}
              >
                Close
              </Button>
              <Button
                onClick={handleCancel}
                className="delete-btn transition duration-700 ease-in-out font-medium text-red-500 border-red-500"
              >
                Cancel the Invoice
              </Button>
            </div>
          </div>,
        ]}
      >
        <div>
          <div className="flex justify-center item-center py-2">
            <DeleteSvg className="text-red-600" width={40} height={40} />
          </div>

          <div className="py-4">
            <div className="text-xl text-medium text-center">
              Your about to cancel the invoice
            </div>
            <div className="py-4">
              <div className="text-base text-gray-400 text-center">
                Are you sure want to cancel the invoice ? You
              </div>
              <div className="text-base text-gray-400 text-center">
                will <span className="text-red-500">not be able to revert</span>
                &nbsp;this.
              </div>
            </div>
          </div>
        </div>
      </Modal>


      {isCategoryModalOpen && (
        <AssignCategoryModal
          open={isCategoryModalOpen}
          onClose={() => setIsCategoryModalOpen(false)}
          selectedProductIds={[]}
          onSuccess={handleAssignmentSuccess}
          productData={productData}
          cat_Id={cat_Id}
        />
      )}

      {isBrandModalOpen && (
        <AssignBrandModal
          open={isBrandModalOpen}
          onClose={() => setIsBrandModalOpen(false)}
          selectedProductIds={[]}
          onSuccess={handleAssignmentSuccess}
          productData={productData}
          brand_Id={brand_Id}
        />
      )}

      {isUnitModalOpen && (
        <AssignUnitModal
          open={isUnitModalOpen}
          onClose={() => setIsUnitModalOpen(false)}
          selectedProductIds={[]}
          onSuccess={handleAssignmentSuccess}
          productData={productData}
          unitData={unitData}
          unit_Id={unit_Id}
        />
      )}

      {edit && canEdit && (
        <button
          className="mx-2 hover:text-[#2d53da]"
          onClick={(e) => {
            e.stopPropagation();
            navigate(edit);
          }}
        >
          <FormOutlined />
        </button>
      )}

      {edit && !canEdit && (
        <button
          className="mx-2 text-gray-400 cursor-not-allowed opacity-50"
          disabled
          title="No edit permission"
        >
          <FormOutlined />
        </button>
      )}

      {type === "category" && (
        <FeatureLockWrapper
          featureKey="category_assignment"
          onClick={handleLockedClick}
        >
          <button
            className={`mx-2 ${
              catUnlocked && canEdit
                ? "hover:text-green-600"
                : "text-gray-400 cursor-not-allowed opacity-50"
            }`}
            onClick={catUnlocked && canEdit ? handleCategoryModal : undefined}
            title={
              catUnlocked
                ? "Assign Category"
                : "Unlock Category Assignment to assign categories"
            }
            disabled={!canEdit}
          >
            <TagsOutlined />
          </button>
        </FeatureLockWrapper>
      )}

      {type === "brand" && (
        <FeatureLockWrapper
          featureKey="brand_assignment"
          onClick={handleLockedClick}
        >
          <button
            className={`mx-2 ${
              brandUnlocked && canEdit
                ? "hover:text-green-600"
                : "text-gray-400 cursor-not-allowed opacity-50"
            }`}
            onClick={brandUnlocked && canEdit ? handleBrandModal : undefined}
            title={
              brandUnlocked
                ? "Assign Brand"
                : "Unlock Brand Assignment to assign brands"
            }
            disabled={!canEdit}
          >
            <ShopOutlined />
          </button>
        </FeatureLockWrapper>
      )}

      {type === "unit" && (
        <FeatureLockWrapper
          featureKey="unit_assignment"
          onClick={handleLockedClick}
        >
          <button
            className={`mx-2 ${
              unitUnlocked && canEdit
                ? "hover:text-green-600"
                : "text-gray-400 cursor-not-allowed opacity-50"
            }`}
            onClick={unitUnlocked && canEdit ? handleUnitModal : undefined}
            title={
              unitUnlocked
                ? "Assign Unit with Conversion"
                : "Unlock Unit Assignment to assign units"
            }
            disabled={!canEdit}
          >
            <AppstoreOutlined />
          </button>
        </FeatureLockWrapper>
      )}

      {/* {api && canDelete && (
        <button className="mx-2 hover:text-red-500">
          <DeleteOutlined onClick={handleModal} />
        </button>
      )} */}

      {api && canDelete && (
        <button
          className="mx-2"
          disabled={deleting}
          style={{
            opacity: deleting ? 0.5 : 1,
            cursor: deleting ? "not-allowed" : "pointer",
          }}
        >
          <DeleteOutlined
            onClick={deleting ? undefined : handleModal}
            spin={deleting} // ← shows Ant Design spinner
          />
        </button>
      )}

      {api && !canDelete && (
        <button
          className="mx-2 text-gray-400 cursor-not-allowed opacity-50"
          disabled
          title="No delete permission"
        >
          <DeleteOutlined />
        </button>
      )}

       {cancelApi && canCancel && (
        <button
          className="mx-2 hover:text-orange-500"
          onClick={handleCancelModal}
          title="Cancel"
        >
          <CloseCircleOutlined />
        </button>
      )}

      {cancelApi && !canCancel && (
        <button
          className="mx-2 text-gray-400 cursor-not-allowed opacity-50"
          disabled
          title="No cancel permission"
        >
          <CloseCircleOutlined />
        </button>
      )}


      {selectedFeature && (
        <FeatureUnlockRequestModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setSelectedFeature(null);
          }}
          feature={selectedFeature}
          onSuccess={() => {
            console.log("Feature unlocked successfully!");
          }}
        />
      )}
    </div>
  );
};

export default ActionButton;
